// import React, { useState } from 'react';
// import ballImage from '../../assets/images/ballwithshadow.png';

// export const WelcomeCoachModal = ({
//   isOpen,
//   onClose,
//   coachName = "JAMES WALKER",
//   ballImg = ballImage
// }) => {
//   const [doNotShowAgain, setDoNotShowAgain] = useState(false);

//   if (!isOpen) return null;

//   const features = [
//     "Navigate JUCO Pipeline's database to fill out your roster",
//     "Search through every team in the country",
//     "Track commitment status of every player in the country",
//     "Follow players' progress through the season",
//     "Use statistics to back up your decisions"
//   ];

//   const handleBackdropClick = (e) => {
//     // Close modal only if clicking the backdrop, not the modal content
//     if (e.target === e.currentTarget) {
//       onClose();
//     }
//   };

//   const handleCheckboxChange = (e) => {
//     const checked = e.target.checked;
//     setDoNotShowAgain(checked);

//     // Immediately save to localStorage when checkbox is checked
//     if (checked) {
//       localStorage.setItem('coachWelcomeModalSeen', 'true');
//     } else {
//       localStorage.removeItem('coachWelcomeModalSeen');
//     }
//   };

//   return (
//     <div
//       className="fixed inset-0 flex items-center justify-center z-50 bg-black/40 p-4 animate-fadeIn"
//       onClick={handleBackdropClick}
//     >
//       <div className="w-full max-w-[1200px] rounded-2xl lg:rounded-3xl bg-jp-card border border-jp-outline/70 shadow-2xl p-6 md:p-10 lg:p-12 relative flex flex-col justify-center items-center animate-scaleIn overflow-hidden">
//         <style>{`
//           @keyframes fadeIn {
//             from { opacity: 0; }
//             to { opacity: 1; }
//           }
//           @keyframes scaleIn {
//             from { opacity: 0; transform: scale(0.95); }
//             to { opacity: 1; transform: scale(1); }
//           }
//           .animate-fadeIn {
//             animation: fadeIn 0.3s ease-out;
//           }
//           .animate-scaleIn {
//             animation: scaleIn 0.4s ease-out;
//           }
//         `}</style>

//         {/* Baseball Background Image */}
//         <img
//           src={ballImg}
//           alt="Baseball"
//           className="absolute pointer-events-none opacity-50"
//           style={{
//             left: "50%",
//             top: "60%",
//             transform: "translate(-50%, -50%)",
//             width: "800px",
//             height: "auto",
//             zIndex: 0,
//           }}
//         />

//         {/* Close button */}
//         <button
//           className="absolute top-4 right-4 text-jp-muted hover:text-jp-ink text-3xl font-light leading-none transition-colors z-10"
//           onClick={onClose}
//           aria-label="Close"
//         >
//           ×
//         </button>

//         {/* Header Section */}
//         <div className="w-full text-center mb-8 lg:mb-10 relative z-10">
//           <h1 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-extrabold text-jp-ink mb-3 lg:mb-4 tracking-wide flex items-center justify-center gap-2 flex-wrap">
//             <span>WELCOME, {coachName}!</span>
//             <span role="img" aria-label="wave" className="text-3xl lg:text-4xl">👋</span>
//           </h1>
//           <p className="text-jp-ink text-sm sm:text-base lg:text-lg font-light max-w-3xl mx-auto px-4 mb-6 lg:mb-8 leading-relaxed">
//             Welcome to your personal JUCO Pipeline account—the central hub for managing your team and finding talented players
//           </p>
//           <h2 className="text-lg sm:text-xl lg:text-2xl font-bold text-jp-ink tracking-wide">
//             HERE YOU CAN:
//           </h2>
//         </div>

//         {/* Features Section with Baseball */}
//         <div className="relative w-full mb-10 lg:mb-12 z-10">
//           {/* Features Grid */}
//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3 sm:gap-4 lg:gap-4 xl:gap-6 px-2 sm:px-4 lg:px-6 relative z-10">
//             {features.map((feature, idx) => (
//               <div
//                 key={idx}
//                 className="bg-jp-section border border-jp-outline/50 rounded-xl px-4 py-6 flex items-center justify-center text-jp-ink shadow-lg text-sm sm:text-base lg:text-lg font-medium text-center transition-transform hover:scale-105"
//                 style={{ minHeight: "110px" }}
//               >
//                 {feature}
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Bottom Text */}
//         <p className="text-jp-ink text-base sm:text-lg lg:text-xl font-light text-center max-w-3xl px-8 mt-16 lg:mb-10 leading-relaxed relative z-10">
//           JUCO Pipeline helps optimize the recruiting process so you can focus on building a strong and successful team!
//         </p>

//         {/* Next Button */}
//         <button
//           onClick={onClose}
//           className="border-2 border-jp-line text-jp-ink font-semibold text-lg lg:text-xl rounded-xl px-16 py-3 bg-transparent hover:bg-jp-section transition-all duration-300 outline-none focus:ring-2 focus:ring-jp-accent/40 relative z-10"
//         >
//           NEXT
//         </button>

//         {/* Do Not Show Again Checkbox */}
//         <div className="mt-6 flex items-center justify-center gap-2 relative z-10">
//           <input
//             type="checkbox"
//             id="doNotShowAgain"
//             checked={doNotShowAgain}
//             onChange={handleCheckboxChange}
//             className="w-4 h-4 rounded border-2 border-jp-line bg-transparent checked:bg-jp-accent checked:border-jp-accent focus:ring-2 focus:ring-jp-accent/40 cursor-pointer"
//           />
//           <label
//             htmlFor="doNotShowAgain"
//             className="text-jp-ink/90 text-sm lg:text-base font-light cursor-pointer select-none"
//           >
//             Do not show again
//           </label>
//         </div>
//       </div>
//     </div>
//   );
// };



import React, { useState } from 'react';
import ballImage from '../../assets/images/ballwithshadow.png';

export const WelcomeCoachModal = ({
  isOpen,
  onClose,
  coachName = "JAMES WALKER",
  ballImg = ballImage
}) => {
  const [doNotShowAgain, setDoNotShowAgain] = useState(false);

  if (!isOpen) return null;

  const features = [
    "Navigate JUCO Pipeline's database to fill out your roster",
    "Search through every team in the country",
    "Track commitment status of every player in the country",
    "Follow players' progress through the season",
    "Use statistics to back up your decisions"
  ];

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleCheckboxChange = (e) => {
    const checked = e.target.checked;
    setDoNotShowAgain(checked);

    if (checked) {
      localStorage.setItem('coachWelcomeModalSeen', 'true');
    } else {
      localStorage.removeItem('coachWelcomeModalSeen');
    }
  };

  return (
    <div
      className="fixed inset-0 flex items-center justify-center z-50 bg-black/40 p-4 animate-fadeIn overflow-y-auto"
      onClick={handleBackdropClick}
    >
      <div className="w-full max-w-[1200px] my-auto rounded-2xl lg:rounded-3xl bg-jp-card border border-jp-outline/70 shadow-2xl relative flex flex-col justify-center items-center animate-scaleIn overflow-hidden max-h-[95vh] md:max-h-[90vh]">
        <style>{`
          @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }
          @keyframes scaleIn {
            from { opacity: 0; transform: scale(0.95); }
            to { opacity: 1; transform: scale(1); }
          }
          .animate-fadeIn {
            animation: fadeIn 0.3s ease-out;
          }
          .animate-scaleIn {
            animation: scaleIn 0.4s ease-out;
          }
        `}</style>

        {/* Scrollable Content Container */}
        <div className="overflow-y-auto overflow-x-hidden w-full h-full p-6 md:p-10 lg:p-12">
          {/* Baseball Background Image */}
          <img
            src={ballImg}
            alt="Baseball"
            className="absolute pointer-events-none opacity-50 hidden md:block"
            style={{
              left: "50%",
              top: "60%",
              transform: "translate(-50%, -50%)",
              width: "800px",
              height: "auto",
              zIndex: 0,
            }}
          />

          {/* Close button */}
          <button
            className="absolute top-4 right-4 text-jp-muted hover:text-jp-ink text-3xl font-light leading-none transition-colors z-10"
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>

          {/* Header Section */}
          <div className="w-full text-center mb-6 md:mb-8 lg:mb-10 relative z-10">
            <h1 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-extrabold text-jp-ink mb-3 lg:mb-4 tracking-wide flex items-center justify-center gap-2 flex-wrap">
              <span>WELCOME, {coachName}!</span>
              <span role="img" aria-label="wave" className="text-3xl lg:text-4xl">👋</span>
            </h1>
            <p className="text-jp-ink text-sm sm:text-base lg:text-lg font-light max-w-3xl mx-auto px-2 sm:px-4 mb-4 md:mb-6 lg:mb-8 leading-relaxed">
              Welcome to your personal JUCO Pipeline account—the central hub for managing your team and finding talented players
            </p>
            <h2 className="text-lg sm:text-xl lg:text-2xl font-bold text-jp-ink tracking-wide">
              HERE YOU CAN:
            </h2>
          </div>

          {/* Features Section */}
          <div className="relative w-full mb-6 md:mb-10 lg:mb-12 z-10">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3 sm:gap-4 lg:gap-4 xl:gap-6 px-2 sm:px-4 lg:px-6 relative z-10">
              {features.map((feature, idx) => (
                <div
                  key={idx}
                  className="bg-jp-section border border-jp-outline/50 rounded-xl px-4 py-6 flex items-center justify-center text-jp-ink shadow-lg text-sm sm:text-base lg:text-lg font-medium text-center transition-transform hover:scale-105"
                  style={{ minHeight: "110px" }}
                >
                  {feature}
                </div>
              ))}
            </div>
          </div>

          {/* Bottom Text */}
          <p className="text-jp-ink text-base sm:text-lg lg:text-xl font-light text-center max-w-3xl mx-auto px-4 sm:px-8 mb-6 md:mb-8 lg:mb-10 leading-relaxed relative z-10">
            JUCO Pipeline helps optimize the recruiting process so you can focus on building a strong and successful team!
          </p>

          {/* Next Button */}
          <div className="flex flex-col items-center gap-4 md:gap-6 pb-4 relative z-10">
            <button
              onClick={onClose}
              className="px-12 sm:px-16 py-4 text-base font-bold uppercase tracking-wider bg-gradient-to-r from-cyan-400 via-cyan-500 to-blue-600 text-slate-900 rounded-xl hover:brightness-110 transition-all shadow-lg shadow-cyan-500/20 focus:outline-none focus-visible:ring-2 focus-visible:ring-jp-accent focus-visible:ring-offset-2 focus-visible:ring-offset-jp-card active:scale-[0.98]"
            >
              NEXT
            </button>

            {/* Do Not Show Again Checkbox */}
            <div className="flex items-center justify-center gap-2">
              <input
                type="checkbox"
                id="doNotShowAgain"
                checked={doNotShowAgain}
                onChange={handleCheckboxChange}
                className="w-4 h-4 rounded border-2 border-jp-line bg-transparent checked:bg-jp-accent checked:border-jp-accent focus:ring-2 focus:ring-jp-accent/40 cursor-pointer"
              />
              <label
                htmlFor="doNotShowAgain"
                className="text-jp-ink/90 text-sm lg:text-base font-light cursor-pointer select-none"
              >
                Do not show again
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
